import React, { Component } from "react";
import { Link } from "react-router-dom";
import firetoast from "./../Utils/Firetoast";
import logo from "../../images/logo.png";
class NavbarThree extends Component {
  state = {
    sidebarModal: false,
  };
  toggleModal = () => {
    this.setState({
      sidebarModal: !this.state.sidebarModal,
    });
  };
  state = {
    searchForm: false,
  };
  handleSearchForm = () => {
    this.setState((prevState) => {
      return {
        searchForm: !prevState.searchForm,
      };
    });
  };

  // Navbar
  _isMounted = false;
  state = {
    display: false,
    collapsed: true,
  };
  toggleNavbar = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };
  componentDidMount() {
    let elementId = document.getElementById("navbar");
    document.addEventListener("scroll", () => {
      if (window.scrollY > 170) {
        elementId.classList.add("is-sticky");
      } else {
        elementId.classList.remove("is-sticky");
      }
    });
    window.scrollTo(0, 0);
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  render() {
    let { products } = this.props;
    const { collapsed } = this.state;
    const classOne = collapsed
      ? "collapse navbar-collapse"
      : "collapse navbar-collapse show";
    const classTwo = collapsed
      ? "navbar-toggler navbar-toggler-right collapsed"
      : "navbar-toggler navbar-toggler-right";
    return (
      <>
        <div id="navbar" className="navbar-area">
          <div className="adani-nav">
            <div className="container">
              <nav className="navbar navbar-expand-md navbar-light">
                <Link to="/">
                  <a className="navbar-brand">
                    <img src={logo} alt="logo" style={{ height: "80px" }} />
                  </a>
                </Link>

                <button
                  onClick={this.toggleNavbar}
                  className={classTwo}
                  type="button"
                  data-toggle="collapse"
                  data-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="icon-bar top-bar"></span>
                  <span className="icon-bar middle-bar"></span>
                  <span className="icon-bar bottom-bar"></span>
                </button>

                <div className={classOne} id="navbarSupportedContent">
                  <ul
                    className="navbar-nav"
                    style={{
                      width: "100%",
                      marginLeft: "inherit",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div className="d-flex">
                      <li>
                        <Link
                          to="/forms"
                          activeClassName="active"
                          style={{ padding: "7px 20px" }}
                        >
                          <a className="nav-link">Create Forms</a>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/form-history"
                          activeClassName="active"
                          style={{ padding: "7px 20px" }}
                        >
                          <a className="nav-link">History</a>
                        </Link>
                      </li>
                    </div>
                    <div className="d-flex">
                      <li>
                        <Link
                          to="/user-profile"
                          activeClassName="active"
                          style={{ padding: "7px 20px" }}
                        >
                          <a className="nav-link">Profile</a>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          activeClassName="active"
                          style={{ padding: "7px 20px" }}
                          onClick={() => {
                            localStorage.clear();
                            firetoast(
                              "Logging Out...",
                              "info",
                              3000,
                              "top-right"
                            );
                            setTimeout(() => {
                              window.location.href = "/";
                            }, 3000);
                          }}
                        >
                          <a className="nav-link">Log Out</a>
                        </Link>
                      </li>
                    </div>
                  </ul>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default NavbarThree;
